import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import AboutIntroduction from "../pages/about/introduction/page";
import AboutOrganization from "../pages/about/organization/page";
import AboutInquiry from "../pages/about/inquiry/page";
import Research from "../pages/research/page";
import PartnersHuaqiao from "../pages/partners/huaqiao/page";
import NewsArticles from "../pages/news/articles/page";
import NewsBrand from "../pages/news/brand/page";
import NewsConference from "../pages/news/conference/page";
import Rankings2025Top100 from "../pages/rankings/2025-top100/page";
import Contact from "../pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about/introduction",
    element: <AboutIntroduction />,
  },
  {
    path: "/about/organization",
    element: <AboutOrganization />,
  },
  {
    path: "/about/board",
    element: <Navigate to="/about/organization" replace />,
  },
  {
    path: "/about/inquiry",
    element: <AboutInquiry />,
  },
  {
    path: "/research",
    element: <Research />,
  },
  {
    path: "/partners/huaqiao",
    element: <PartnersHuaqiao />,
  },
  {
    path: "/news/articles",
    element: <NewsArticles />,
  },
  {
    path: "/news/brand",
    element: <NewsBrand />,
  },
  {
    path: "/news/conference",
    element: <NewsConference />,
  },
  {
    path: "/rankings/2025-top100",
    element: <Rankings2025Top100 />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;